import { ReactNode } from "react";

import { twMerge } from "@krea/shared/design-system/tailwind-utils";

interface IDialogTitleProps {
  className?: string;
  title: string;
  closeButton?: ReactNode;
}

export const DialogTitle = ({
  className,
  title,
  closeButton,
}: IDialogTitleProps) => {
  return (
    <div
      className={twMerge(
        "tw-grow-0 tw-shrink-0 tw-pt-5 tw-px-6 tw-border-b",
        className,
      )}
    >
      <div className="tw-flex tw-items-center tw-justify-between tw-pb-5">
        <h5 className="tw-m-0 tw-p-0">{title}</h5>
        {closeButton}
      </div>
    </div>
  );
};
